import { render, staticRenderFns } from "./StepUserInfo.vue?vue&type=template&id=27f96e0d&"
import script from "./StepUserInfo.vue?vue&type=script&lang=js&"
export * from "./StepUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports